import { computed } from 'vue';
import { useStore } from 'vuex';

const mapGetters = (keys) => {
  const store = useStore();

  if (Array.isArray(keys)) {
    return Object.fromEntries(keys.map((key) => [key, computed(() => store.getters[key])]));
  }

  return Object.fromEntries(
    Object.keys(store.getters).map((getter) => [getter, computed(() => store.getters[getter])]),
  );
};

const mapActions = (keys) => {
  const store = useStore();

  if (Array.isArray(keys)) {
    return Object.fromEntries(keys.map((key) => [key, (payload) => store.dispatch(key, payload)]));
  }

  return Object.fromEntries(
    Object.keys(store._actions).map((action) => [action, (payload) => store.dispatch(action, payload)]),
  );
};
const mapMutations = (keys) => {
  const store = useStore();

  if (Array.isArray(keys)) {
    return Object.fromEntries(keys.map((key) => [key, (payload) => store.commit(key, payload)]));
  }

  return Object.fromEntries(
    Object.keys(store._mutations).map((mutation) => [mutation, (payload) => store.commit(mutation, payload)]),
  );
};

export { mapGetters, mapMutations, mapActions };
